"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/website/ui/Button";
import { Logo } from "@/components/website/ui/Logo";

const links = [
  { href: "/", label: "Home" },
  { href: "/product", label: "Product" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

export function Navbar() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-divider bg-white">
      <div className="mx-auto flex h-14 max-w-[1440px] items-center justify-between px-6 lg:h-16 lg:px-[100px]">
        <Logo />

        <nav className="hidden items-center gap-8 md:flex">
          {links.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className={`text-sm transition-colors ${
                pathname === href
                  ? "font-medium text-text"
                  : "text-muted hover:text-text"
              }`}
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-6 md:flex">
          <Button variant="outline" href="/#book-demo">
            Book a demo
          </Button>
          <Button href="/login">Login</Button>
        </div>

        <button
          type="button"
          className="md:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-divider bg-white px-6 py-4 md:hidden">
          <nav className="flex flex-col gap-4">
            {links.map(({ href, label }) => (
              <Link
                key={href}
                href={href}
                onClick={() => setOpen(false)}
                className={`text-sm ${
                  pathname === href ? "font-medium text-text" : "text-muted"
                }`}
              >
                {label}
              </Link>
            ))}
            <div className="flex flex-col gap-3 pt-2">
              <Button variant="outline" href="/#book-demo">
                Book a demo
              </Button>
              <Button href="/login">Login</Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
